/**
 * Helper para baseURL da API — evita duplicação entre b2b e b2b2c.
 * Nos apps Vite, import.meta.env.VITE_API_URL é definido.
 */
export function getApiBaseUrl(): string {
  const meta = import.meta as { env?: { VITE_API_URL?: string } };
  if (typeof meta !== 'undefined' && meta.env?.VITE_API_URL) {
    return meta.env.VITE_API_URL;
  }
  return '/api';
}
